function getResponsibleUpdateState(state) {
  return {
    collaboratorsInfo: state.responsibleUpdate.collaborators,
    errorCollaborators: state.responsibleUpdate.errorCollaborators,
    loadingCollaborators: state.responsibleUpdate.loadingCollaborators,
    hasCollaboratorsInfo: state.responsibleUpdate.hasCollaboratorsInfo,
    updatedUserResponsible: state.responsibleUpdate.updatedUserResponsible,
    loadingUpdateUserResponsible: state.responsibleUpdate.loadingUpdateUserResponsible,
    errorUpdatingUserResponsible: state.responsibleUpdate.errorUpdatingUserResponsible,
    bulkSuccessful: state.responsibleUpdate.bulkSuccessful,
    bulkError: state.responsibleUpdate.bulkError
  };
}

export { getResponsibleUpdateState };
